const LAST_CREDIT_THRESHOLD = 5; // seconds

export const isLastCredit = (endTime: number, duration: number): boolean =>
    Math.abs(duration - endTime) <= LAST_CREDIT_THRESHOLD;

export const isMuted = (volume: number) => volume < Number.EPSILON;
